var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import { _loginWithEmailAndPassword, sendPasswordResetEmail, } from '../../../redux/actions';
import Button from '../../../components/Button';
import InputCell from '../../../components/InputCell';
import { displayToast } from '../../../components/Toast';
export default function LoginForm(props) {
    var _this = this;
    var _a = useState(props.email), email = _a[0], setEmail = _a[1];
    var _b = useState(''), password = _b[0], setPassword = _b[1];
    var _c = useState(false), wrongPassword = _c[0], setWrongPassword = _c[1];
    var handleLogin = function (email, password) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, _loginWithEmailAndPassword(email, password).catch(function (error) {
                    if ((error === null || error === void 0 ? void 0 : error.code) === 'auth/wrong-password') {
                        setWrongPassword(true);
                    }
                })];
        });
    }); };
    var handleResetPassword = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            sendPasswordResetEmail(email).then(function () {
                displayToast('success', '✉️ Password recovery email sent!', false);
            });
            return [2 /*return*/];
        });
    }); };
    return (React.createElement("div", { className: 'm-4 flex w-full max-w-xs flex-col items-center gap-3' },
        React.createElement("h3", { className: 'mb-4' }, "Log in"),
        React.createElement("form", { className: 'flex w-full max-w-xs flex-col gap-3 text-center' },
            React.createElement(InputCell, { type: 'email', placeholder: 'Email', value: email, displayError: wrongPassword, onChange: setEmail, id: 'email' }),
            React.createElement(InputCell, { type: 'password', placeholder: 'Password', value: password, onChange: function (v) {
                    setPassword(v);
                    setWrongPassword(false);
                }, displayError: wrongPassword, errorMessage: 'Email/password combination is incorrect.', id: 'password' }),
            React.createElement(Button, { label: 'Login', onClick: function () { return handleLogin(email, password); }, id: 'login' })),
        React.createElement("button", { className: 'cursor-pointer underline', onClick: handleResetPassword }, "Forgot password?")));
}
